import { render, staticRenderFns } from "./WesQuestionContainer.vue?vue&type=template&id=47936553&scoped=true"
import script from "./WesQuestionContainer.vue?vue&type=script&lang=js"
export * from "./WesQuestionContainer.vue?vue&type=script&lang=js"
import style0 from "./WesQuestionContainer.vue?vue&type=style&index=0&id=47936553&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47936553",
  null
  
)

export default component.exports